import { render, staticRenderFns } from "./IconBtnMenu.vue?vue&type=template&id=959b4c4c&scoped=true"
import script from "./IconBtnMenu.vue?vue&type=script&lang=js"
export * from "./IconBtnMenu.vue?vue&type=script&lang=js"
import style0 from "./IconBtnMenu.vue?vue&type=style&index=0&id=959b4c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959b4c4c",
  null
  
)

export default component.exports